import { useQuery } from "@apollo/client";
import { PremiumServiceInterestView } from "components/cards";
import { Button } from "components/core";
import { Modal } from "components/layouts";
import { useNavigate, useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { Action } from "components/buttons/action-button";
import { wrapClick } from "utils";
import { GET_PREMIUM_SERVICE_INTEREST } from "./apollo";

export default function ViewPremiumServiceInterestContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const { data, loading } = useQuery(GET_PREMIUM_SERVICE_INTEREST, {
    variables: {
      id: searchParams.id,
    },
    notifyOnNetworkStatusChange: false,
    skip: !searchParams.id,
    fetchPolicy: "network-only",
  });

  const item = data?.premiumServiceInterest;

  const dispatchAction = (action: "schedule" | "cancel") =>
    wrapClick(() => {
      navigate({
        search: (old) => ({
          ...old,
          modal: action as Exclude<Action, "expand" | "goto" | "clone">,
        }),
      });
    });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Premium Service Expression of Interest"
      size="3xl"
      description="Details of the expression of interest are shown below"
      renderActions={() => (
        <>
          {item?.status === "Pending" && (
            <>
              <Button theme="primary" onClick={dispatchAction("schedule")}>
                Confirm Appointment
              </Button>
              <Button theme="danger" onClick={dispatchAction("cancel")}>
                Cancel
              </Button>
            </>
          )}
        </>
      )}
    >
      {item?._id && (
        <PremiumServiceInterestView premiumServiceInterest={item} />
      )}
    </Modal>
  );
}
